import { clientScopedFetch } from './authedFetch';

const BACKEND = process.env.REACT_APP_BACKEND_URL || 'https://autopilot-backend-pn9r.onrender.com';

// Logo upload, routed through the backend.
//
// PHASE 5. This ran entirely in the browser: it listed the client's storage
// folder, removed stale logo.* objects, uploaded the new one, derived a public
// URL and wrote logo_url — four Supabase calls plus a getPublicUrl, all against
// the SIGNED-IN user's scope.
//
// THAT CARRIED A CONFIRMED LIVE BUG. Under the admin act-as-client view the
// signed-in user is the admin, so uploading a logo while viewing a client wrote
// the FILE into the admin's storage folder and the URL onto the admin's
// brand_profile row — while the UI showed the client's Brand Hub. Sending the
// file to POST /api/brand-hub/logo fixes it because the path and the row there
// both derive from requireOwnerOrAdmin's resolved client.
//
// The whole chain moved as ONE unit rather than call by call (the same rule
// applied to BrandHub's fallback-retry pair). Split across round trips a caller
// could strand logo_url pointing at a deleted object, or leave two logo.<ext>
// files behind after an extension change.
//
// clientId is still accepted so callers keep their existing shape and the
// signed-out guard still fires, but it is NOT sent: multipart requests are
// authenticated before multer parses the body, so ?client= — which
// clientScopedFetch attaches — is the only channel that can name a target, and
// a form field would be the body-beats-query hazard in another costume.
//
// The return shape is unchanged ({ publicUrl } | { error, stage }) so both
// callers — OnboardingPanel and BrandHubPanel — are untouched by this move.
export async function uploadLogo({ file, clientId }) {
  if (!file)     return { error: new Error('No file provided'), stage: 'validate' };
  if (!clientId) return { error: new Error('Client ID not found.'), stage: 'validate' };

  const form = new FormData();
  form.append('file', file);

  let res;
  try {
    // No Content-Type header: the browser must set the multipart boundary.
    res = await clientScopedFetch(`${BACKEND}/api/brand-hub/logo`, { method: 'POST', body: form });
  } catch (err) {
    return { error: err, stage: 'upload' };
  }

  const body = await res.json().catch(() => ({}));
  if (!res.ok || !body.ok) {
    // 'upload' rather than 'db': the endpoint is atomic from the caller's side,
    // so there is no longer a state where the file landed but the row did not.
    // BrandHub's copy distinguishes the two stages in its error copy; reporting
    // 'db' here would name a half-failure that can no longer happen.
    return { error: new Error(body.error || `HTTP ${res.status}`), stage: 'upload' };
  }

  return { publicUrl: body.publicUrl };
}
